import { render, staticRenderFns } from "./searchhistory.vue?vue&type=template&id=273d6e74&"
import script from "./searchhistory.vue?vue&type=script&lang=js&"
export * from "./searchhistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports